import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { merchantPayments } from '@/api/client';
import { Empty } from '@/components/empty';
import { PaymentStatusBadge } from '@/components/status-badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatLyd } from '@/lib/utils';

export const Route = createFileRoute('/m/dashboard')({
  component: MerchantDashboard,
});

function MerchantDashboard() {
  const { t } = useTranslation();
  const recent = useQuery({
    queryKey: ['merchant-payments', { limit: 20 }],
    queryFn: () => merchantPayments.list({ limit: 20 }),
  });

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{t('dashboard.title')}</h1>
      </header>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('payments.title')}</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('payments.cols.created')}</TableHead>
                <TableHead>{t('payments.cols.order_ref')}</TableHead>
                <TableHead>{t('payments.cols.psp')}</TableHead>
                <TableHead>{t('payments.cols.amount')}</TableHead>
                <TableHead>{t('payments.cols.status')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recent.data?.map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="font-mono text-xs whitespace-nowrap">
                    {dayjs(p.created_at).format('MMM D HH:mm:ss')}
                  </TableCell>
                  <TableCell className="font-medium">{p.merchant_order_ref}</TableCell>
                  <TableCell className="capitalize">{p.psp_code}</TableCell>
                  <TableCell className="tabular-nums">{formatLyd(p.amount_minor)}</TableCell>
                  <TableCell>
                    <PaymentStatusBadge status={p.status} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {!recent.isLoading && recent.data?.length === 0 && (
            <Empty title={t('payments.no_results')} className="border-0" />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
